const isMultiPartGeometry = geometryType => geometryType.startsWith('Multi');

export default isMultiPartGeometry;
